'use strict';

var Constructor = require('js/vendor/constructor');
var _ = require('underscore');
var Definition = require('js/lib/composer/definition');


/**
 * Core lib Composer module [[Tests]](../test.html?grep=lib/composer)
 * --------------------
 * This class allows you to 'compose' an object and store it in memory until a point you invalidate it.
 *
 * @exports Composer
 * @constructor
 * @alias module:lib/composer
 */
var Composer = Constructor.extend();

/**
 * Reference to lib/composer/definition class
 * @type {ComposerDefinition}
 */
Composer.prototype.Definition = Definition;

/**
 * Initialize the composer in the given context
 * @param  {Object} context The context you want to keep this composer in. This is passed by default to definitions unless specified.
 * @return {type}         [description]
 */
Composer.prototype.initialize = function(context) {
  this.definitions = {};
  this.context = context;
};

/**
 * Compose an object.
 * @callback compose
 */

/**
 * Validate an object.
 * @callback isValid
 * @return Bool
 */

/**
 * Register a given definition (or create one using passed params)
 * @param  {String}  name        The name to store under
 * @param  {(ComposerDefinition|compose)}  definition An initialised Definition or, if creating on the fly, a compose callback
 * @param  {Boolean} [isValid]   Callback to determine whether this object is valid or should be removed from store (if emmitted this can be used as context param)
 * @param  {Object}  [context]   The context the definition should be bound to
 * @return {ComposerDefinition}  The created definition
 */
Composer.prototype.register = function(name, definition, isValid, context) {
  if (!_.isFunction(isValid)) {
    context = isValid;
    isValid = function() {
      return true;
    };
  }

  if (!(definition instanceof Definition)) {
    definition = (new Definition(definition, isValid)).context(context || this.context);
  }

  this.definitions[name] = definition;

  return definition;
};

/**
 * Remove a definition
 * @param  {String} name The name of the definition
 */
Composer.prototype.unregister = function(name) {
  delete this.definitions[name];
};

/**
 * Return the definition instance (or undefined)
 * @param  {String} name The name of the definition
 * @return {ComposerDefinition|undefined}      Whatever the composed object is. Or undefined if not registered.
 */
Composer.prototype.fetch = function(name, ...args) {
  return this.definitions[name] && this.definitions[name].fetch(...args);
};

/**
 * Return a stored definition (or undefined)
 * @param  {String} name The name of the definition
 * @return {Object}      The Definition
 */
Composer.prototype.get = function(name) {
  return this.definitions[name];
};

/**
 * Invalidate all or a given definition. If force is not passed then a soft invalidation occurs.
 * A soft invalidation only causes a deref to the instance if validation fails.
 * @param  {String} name  The stored name
 * @param  {Boolean} force Whether to force invalidation or not
 */
Composer.prototype.invalidate = function(name, force) {
  if (_.isBoolean(name)) {
    force = name;
    name = null;
  }

  // Simply invalidate the defined definition if we are provided a name
  if (name) {
    return this.definitions[name] && this.definitions[name].invalidate(force);
  }

  // Otherwise lets invalidate everything
  for (name in this.definitions) {
    if (this.definitions.hasOwnProperty(name)) {
      this.invalidate(name, force);
    }
  }
};

module.exports = Composer;



// WEBPACK FOOTER //
// ./app/assets/js/lib/composer.js